import {useMeStore} from '@progyny/store/meStore'

type companyName = string

export function useCompany(companyName: companyName) {
  const user = useMeStore((s) => s.user)
  const regex = new RegExp(companyName, 'i')

  return regex.test(user?.company.name as companyName)
}
